// extracted by mini-css-extract-plugin
module.exports = {"root":"link_root__3xN7k"};